import template from './changer-list-view.html';
import controller from './changer-list-view.controller';
import './changer-list-view.styl';

const changerListViewComponent = {
  template,
  controller,
  controllerAs: 'changerListView',
  require: {
    app: '^^app'
  }
};

export default changerListViewComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/changer-list-view/changer-list-view.component.js
 **/